import React from 'react'
import { inputClass, inputStyle, labelClass, labelStyle } from '@/lib/styleKit'

interface SmsTestConfigProps {
  config: {
    send_to: 'self' | 'test_address' | 'real_contact'
    test_phone: string
  }
  onChange: (config: any) => void
}

export const SmsTestConfig: React.FC<SmsTestConfigProps> = ({ config, onChange }) => {
  return (
    <div className="space-y-3">
      <div>
        <label className={labelClass} style={labelStyle}>Send To</label>
        <div className="space-y-1.5">
          {[
            { value: 'self' as const, label: 'My phone number' },
            { value: 'test_address' as const, label: 'Test phone number' },
            { value: 'real_contact' as const, label: 'Real contact' },
          ].map(opt => (
            <label key={opt.value} className="flex items-center gap-2 text-sm cursor-pointer">
              <input
                type="radio"
                name="sms_send_to"
                value={opt.value}
                checked={config.send_to === opt.value}
                onChange={() => onChange({ ...config, send_to: opt.value })}
                className="text-primary"
              />
              <span className="text-foreground">{opt.label}</span>
            </label>
          ))}
        </div>
      </div>

      {(config.send_to === 'self' || config.send_to === 'test_address') && (
        <div>
          <label className={labelClass} style={labelStyle}>Phone Number</label>
          <input
            type="tel"
            value={config.test_phone}
            onChange={e => onChange({ ...config, test_phone: e.target.value })}
            placeholder="+1234567890"
            className={inputClass}
            style={inputStyle}
          />
        </div>
      )}
    </div>
  )
}
